import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "photos"
const PhotosIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M16.125 8.625C17.575 8.625 18.75 9.8 18.75 11.25S17.575 13.875 16.125 13.875 13.5 12.7 13.5 11.25 14.675 8.625 16.125 8.625M16.125 10.125C15.504 10.125 15 10.629 15 11.25S15.504 12.375 16.125 12.375 17.25 11.871 17.25 11.25 16.746 10.125 16.125 10.125"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M19.875 6.375C20.703 6.375 21.375 7.047 21.375 7.875V19.875C21.375 20.703 20.703 21.375 19.875 21.375H7.875C7.047 21.375 6.375 20.703 6.375 19.875V7.875Q6.375 7.719 6.405 7.573 6.436 7.426 6.494 7.29C6.645 6.932 6.933 6.645 7.29 6.493Q7.426 6.436 7.573 6.406T7.875 6.375zM7.875 19.875H17.503Q17.487 19.807 17.466 19.735C17.303 19.165 16.975 18.397 16.31 17.632 15.114 16.26 12.72 14.775 7.875 14.636zM19.875 16.205C19.268 16.333 18.742 16.6 18.325 16.88 18.155 16.994 18.008 17.107 17.885 17.21 18.431 17.98 18.737 18.727 18.908 19.323Q18.995 19.628 19.04 19.875H19.875zM7.875 13.136C12.493 13.262 15.256 14.547 16.895 16.083 17.06 15.943 17.259 15.79 17.488 15.635 18.076 15.24 18.891 14.828 19.875 14.681V7.875H7.875z"
            clipRule="evenodd"
          />
          <path d="M16.5 3C17.328 3 18 3.672 18 4.5V4.875H7.875C6.218 4.875 4.875 6.218 4.875 7.875V18H4.5C3.672 18 3 17.328 3 16.5V4.5C3 3.672 3.672 3 4.5 3z" />
        </svg>
      }
    </span>
  )
}
export default PhotosIcon
